// extracted by mini-css-extract-plugin
export default {"data":"DisplayRecords_data__N8m54","header":"DisplayRecords_header__YB5rN"};